import createIcon from '../../createIcon';

/**
 * @component @name Anchor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTVMMTguNTUgMTYuNTVDMTcuNTkgMTguMjQgMTUuMjIgMTkuNTkgMTMgMTkuOTJWMTFIMTZWOUgxM1Y3LjgyQzE0LjE2IDcuNCAxNSA2LjMgMTUgNUMxNSAzLjM1IDEzLjY1IDIgMTIgMkMxMC4zNSAyIDkgMy4zNSA5IDVDOSA2LjMgOS44NCA3LjQgMTEgNy44MlY5SDhWMTFIMTFWMTkuOTJDOC43OCAxOS41OSA2LjQxIDE4LjI0IDUuNDUgMTYuNTVMNyAxNUwzIDEyVjE1QzMgMTguODggNy45MiAyMiAxMiAyMkMxNi4wOCAyMiAyMSAxOC44OCAyMSAxNVYxMkwxNyAxNVpNMTIgNEMxMi41NSA0IDEzIDQuNDUgMTMgNUMxMyA1LjU1IDEyLjU1IDYgMTIgNkMxMS40NSA2IDExIDUuNTUgMTEgNUMxMSA0LjQ1IDExLjQ1IDQgMTIgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Anchor = createIcon('Anchor', [
  [
    'path',
    {
      d: 'M17 15L18.55 16.55C17.59 18.24 15.22 19.59 13 19.92V11H16V9H13V7.82C14.16 7.4 15 6.3 15 5C15 3.35 13.65 2 12 2C10.35 2 9 3.35 9 5C9 6.3 9.84 7.4 11 7.82V9H8V11H11V19.92C8.78 19.59 6.41 18.24 5.45 16.55L7 15L3 12V15C3 18.88 7.92 22 12 22C16.08 22 21 18.88 21 15V12L17 15ZM12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4Z',
      key: 'ejvtxh',
    },
  ],
]);

export default Anchor;
